import React from 'react';
import Icon, { IIcon } from './Icon';

const ArrowLeftIcon: React.FC<IIcon> = props => (
  <Icon {...props} width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.44194 4.55806C5.68602 4.80214 5.68602 5.19786 5.44194 5.44194L3.50888 7.375H14C14.3452 7.375 14.625 7.65482 14.625 8C14.625 8.34518 14.3452 8.625 14 8.625H3.50888L5.44194 10.5581C5.68602 10.8021 5.68602 11.1979 5.44194 11.4419C5.19786 11.686 4.80214 11.686 4.55806 11.4419L1.55806 8.44194C1.31398 8.19786 1.31398 7.80214 1.55806 7.55806L4.55806 4.55806C4.80214 4.31398 5.19786 4.31398 5.44194 4.55806Z"
    />
  </Icon>
);

export default ArrowLeftIcon;
